import { KYMW2900Component } from './kymw2900.component';

/**
 * 農産フロント連携画面の値を管理するクラス
 *
 * @export KYMW2900Model
 * @class KYMW2900Model
 */
export class KYMW2900Model {

  kymw2900Component: KYMW2900Component;

  /**
   * 取り込むファイルの種類
   * 1:商品企画情報, 2:産地コメント情報
   */
  public uploadType: string = <string>'';
}
